export enum BookingTime {
  Morning = 'Morning',
  Afternoon = 'Afternoon',
  Evening = 'Evening'
}
